export default __webpack_public_path__ + "static/media/McKinsey & Company.e85edcbc.png";